import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {noop} from '@github-ui/noop'
import {clsx} from 'clsx'
import {Link} from '@primer/react'
import {getVariantComment, type ThreadGroupVariant} from '../util/classify-thread'
import {getThreadFileLabel} from '../util/thread-file-label'
import {useNavigateToThreadComment} from '../../../../hooks/use-navigate-to-thread-comment'
import {getThreadCommentHref} from '../../../../helpers/thread-navigation'
import styles from './ThreadFilePath.module.css'

export function ThreadFilePath({thread, variant}: {thread: Thread; variant: ThreadGroupVariant}) {
  const {filePath: displayFilePath, lineText, hasLine} = getThreadFileLabel(thread)

  const commentId = getVariantComment(thread, variant)?.databaseId
  const navigateToComment = useNavigateToThreadComment(thread, noop, commentId)

  if (!displayFilePath) return null

  const ariaLabel = hasLine ? `Go to ${displayFilePath} ${lineText}` : `Go to ${displayFilePath}`

  const pathContent = (
    <>
      <span
        className={clsx(styles['file-name-overflow'], 'd-inline text-mono no-wrap overflow-hidden direction-rtl f6')}
      >
        {/* Ensures path is displayed in left-to-right order despite container direction being right-to-left */}
        &lrm;{displayFilePath}&lrm;
      </span>
      {hasLine && <span className="f6 fgColor-muted text-normal no-wrap ml-2">{lineText}</span>}
    </>
  )

  return (
    <div className={styles.container}>
      {commentId !== undefined && commentId !== null ? (
        <Link
          as="a"
          muted
          href={getThreadCommentHref(thread, commentId)}
          onClick={navigateToComment}
          aria-label={ariaLabel}
          className={styles.filePathLink}
        >
          {pathContent}
        </Link>
      ) : (
        pathContent
      )}
    </div>
  )
}
